import l, { forwardRef as C } from "react";
import { ChevronRight as S } from "@olxbr/ds-icons";
import { Text as L } from "../Text/Text.js";
import { cls as D } from "../../helpers/cls.js";
import { spacingReplace as o } from "../../helpers/spacingReplace.js";
import { sendClickEvent as P } from "./sendClickEvent.js";
import { Link as j } from "../Link/Link.js";
var T = Object.defineProperty,
  I = Object.defineProperties,
  V = Object.getOwnPropertyDescriptors,
  i = Object.getOwnPropertySymbols,
  c = Object.prototype.hasOwnProperty,
  g = Object.prototype.propertyIsEnumerable,
  s = (e, r, a) => r in e ? T(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[r] = a,
  b = (e, r) => {
    for (var a in r || (r = {})) c.call(r, a) && s(e, a, r[a]);
    if (i) for (var a of i(r)) g.call(r, a) && s(e, a, r[a]);
    return e;
  },
  A = (e, r) => I(e, V(r)),
  W = (e, r) => {
    var a = {};
    for (var t in e) c.call(e, t) && r.indexOf(t) < 0 && (a[t] = e[t]);
    if (e != null && i) for (var t of i(e)) r.indexOf(t) < 0 && g.call(e, t) && (a[t] = e[t]);
    return a;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const f = C((e, r) => {
  var a = e,
    {
      links: t,
      className: u,
      backgroundColor: d,
      margin: _,
      marginLeft: v,
      marginBottom: x,
      marginTop: E,
      marginRight: O,
      padding: w,
      paddingLeft: y,
      paddingBottom: h,
      paddingTop: N,
      paddingRight: B
    } = a,
    R = W(a, ["links", "className", "backgroundColor", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight", "padding", "paddingLeft", "paddingBottom", "paddingTop", "paddingRight"]);
  const p = t.length;
  return p === 0 ? l.createElement(l.Fragment, null) : l.createElement("nav", b(A(b({}, R), {
    ref: r,
    className: D(u, o("olx-m", _), o("olx-ml", v), o("olx-mb", x), o("olx-mt", E), o("olx-mr", O), o("olx-p", w), o("olx-pl", y), o("olx-pb", h), o("olx-pt", N), o("olx-pr", B)),
    "data-ds-component": "DS-Breadcrumb",
    "aria-label": "Atalhos de navega\xE7\xE3o"
  }), d && {
    style: {
      backgroundColor: "var(".concat(d, ")")
    }
  }), l.createElement("ol", {
    className: "olx-breadcrumb__list"
  }, t.map((_ref, k) => {
    let {
      url: n,
      label: m
    } = _ref;
    return l.createElement("li", {
      className: "olx-breadcrumb__item",
      key: "breadcrumb__".concat(m),
      "data-url": n
    }, n ? l.createElement(j, {
      href: n,
      key: n,
      variant: "grey",
      onClick: () => P(),
      dsParentName: "Breadcrumb"
    }, m) : l.createElement(L.Caption, {
      weight: "semibold"
    }, m), k < p - 1 ? l.createElement(S, {
      className: "olx-breadcrumb__arrow"
    }) : null);
  })));
});
f.displayName = "Breadcrumb";
export { f as Breadcrumb };